export const ADD_APPS = "ADD_APPS";
export const DELETE_APPS = "DELETE_APPS";
export const UPDATE_APPS = "UPDATE_APPS";
export const SELECTED_ORG = "SELECTED_ORG";
export const REMOVE_SELECTED_ORG = "REMOVE_SELECTED_ORG";
export const UPDATE_APP_VERSION = "UPDATE_APP_VERSION";
export const UPDATE_SELECTED_APP = "UPDATE_SELECTED_APP";
export const UPDATE_APP_LIST = "UPDATE_APP_LIST";
export const UPDATE_APP_BRANCH = "UPDATE_APP_BRANCH";
export const UPDATE_SELECTED_BPMN = "UPDATE_SELECTED_BPMN";
export const UPDATE_SELECTED_DMN = "UPDATE_SELECTED_DMN";
export const FORM_VERSION = "FORM_VERSION";
export const FORM_CORE_VERSION = "FORM_CORE_VERSION";
export const UPDATE_SELECTED_AGENT_NAME = "UPDATE_SELECTED_AGENT_NAME"

export interface DataApps {
  apps: any[];
  SelectedOrg: string;
  appVersion: any;
  selectedApp: any;
  appsList: any[]
  appBranch: any;
  selectedBpmn: any;
  selectedDmn: any;
  formVersion?: any;
  formCoreVersion?: any;
  selectedAiAgentName?: string
}

interface AppsAction {
  type:
  | typeof ADD_APPS
  | typeof DELETE_APPS
  | typeof UPDATE_APPS
  | typeof SELECTED_ORG
  | typeof REMOVE_SELECTED_ORG
  | typeof UPDATE_APP_VERSION
  | typeof UPDATE_SELECTED_APP
  | typeof UPDATE_APP_LIST
  | typeof UPDATE_APP_BRANCH
  | typeof UPDATE_SELECTED_BPMN
  | typeof UPDATE_SELECTED_DMN
  | typeof FORM_VERSION
  | typeof FORM_CORE_VERSION
  | typeof UPDATE_SELECTED_AGENT_NAME
  data: any;
}

export type AppsActionTypes = AppsAction;
